import * as React from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  padding: 12px 6px;

  h5 {
    font-weight: bold;
    margin: 0 0 6px;
  }
`;
const TabDisabledTimeRange = () => /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("h5", null, "No Date/Time Override chosen."), /* @__PURE__ */ React.createElement("p", null, "Use the tabs above to choose a Date & Time Range to Search."));
export default TabDisabledTimeRange;
